<div class="sn-search" [class.sn-search--palette]="variant() === 'palette'">
  <div class="sn-search__field">
    <i class="fa-solid fa-magnifying-glass sn-search__icon" aria-hidden="true"></i>
    <input #input type="text" class="sn-search__input" autocomplete="off" spellcheck="false"
           role="combobox" aria-autocomplete="list" aria-label="Search the menu"
           [attr.aria-expanded]="!!query.trim()" [attr.aria-controls]="listId"
           [attr.aria-activedescendant]="activeIndex >= 0 && query.trim() ? optionId(activeIndex) : null"
           [attr.aria-keyshortcuts]="isMac ? 'Meta+K' : 'Control+K'"
           placeholder="Search the menu" [value]="query"
           (input)="onInput($any($event.target).value)" (keydown)="onKeydown($event)">
    @if (!query) {
    <kbd class="sn-search__kbd" aria-hidden="true">{{ shortcut }}</kbd>
    }
    @if (query) {
    <button type="button" class="sn-icon-button sn-search__clear" aria-label="Clear search"
            (click)="onInput(''); focus()">
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
    }
  </div>

  @if (query.trim()) {
  <ul class="sn-search__results" role="listbox" [id]="listId" aria-label="Menu search results">
    @for (result of results; track trackByKey(i, result); let i = $index) {
    <li class="sn-search__option" role="option"
        [id]="optionId(i)" [attr.aria-selected]="i === activeIndex" [class.sn-search__option--active]="i === activeIndex"
        (mousedown)="$event.preventDefault()" (mouseenter)="activeIndex = i"
        (click)="open(result.entry, $event.ctrlKey || $event.metaKey)" (auxclick)="open(result.entry, true)">
      <i class="fa-fw sn-search__option-icon" [class]="result.entry.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
      <span class="sn-search__option-text">
        <span class="sn-search__option-label">@for (segment of segments(result); track $index) {
          @if (segment.match) {
          <mark>{{ segment.text }}</mark>
          } @else {
          <ng-container>{{ segment.text }}</ng-container>
          }
        }</span>
        @if (result.entry.trail.length) {
        <span class="sn-search__option-trail">{{ result.entry.trail.join(' › ') }}</span>
        }
      </span>
      @if (isStarred(result.entry)) {
      <i class="fa-solid fa-star sn-search__option-star" aria-label="Favorite"></i>
      }
      @if (result.entry.external) {
      <i class="fa-solid fa-arrow-up-right-from-square sn-search__option-external" aria-hidden="true"></i>
      }
    </li>
    }
    @if (!results.length) {
    <li class="sn-search__empty" role="presentation">No menu items match “{{ query }}”</li>
    }
  </ul>
  }

  @if (variant() === 'palette') {
  <p class="sn-search__hint">
    <kbd>↑</kbd><kbd>↓</kbd> move · <kbd>↵</kbd> open · <kbd>⇧</kbd><kbd>↵</kbd> favorite · <kbd>esc</kbd> close
  </p>
  }
</div>
